<div class="d-flex align-items-start gap-2 mb-3">
  <i class="icon-info icon-text-blue" style="width: 16px; height: 16px; flex-shrink: 0;"></i>
  <div class="text-text-blue" style="font-size: 12px">
    <i rtI18n>By checking the following boxes, you provide your express written consent to receive recurring automated marketing and informational communications (including calls, texts, and SMS/MMS) from the following schools at the phone number provided. Consent is not a condition of your student's education. Message and data rates may apply. You may revoke consent at any time by unchecking the boxes.</i>
  </div>
</div>

<div class="consent-section">
  @for (school of schools; track school.SchoolId) {
    <div class="consent-school">
      <p class="text-header-blue mb-1"><b>{{ school.SchoolName }}</b></p>
      <div class="consent-checkbox">
        <mat-checkbox [(ngModel)]="school.Marketing" [disabled]="readonly"
                      (ngModelChange)="onConsentChange(school, $event)">
          <span rtI18n>I agree to receive marketing communications (from teachers or principals).</span>
        </mat-checkbox>
      </div>
      <div class="consent-checkbox">
        <mat-checkbox [(ngModel)]="school.Operations" [disabled]="readonly"
                      (ngModelChange)="onConsentChange(school, $event)">
          <span rtI18n>I agree to receive communications from the school necessary for the education of my student(s).</span>
        </mat-checkbox>
      </div>
      <div class="consent-checkbox">
        <mat-checkbox [checked]="isDeclined(school)" [disabled]="readonly"
                      (change)="onDeclineChange(school, $event.checked)">
          <span rtI18n>I do not wish to receive these communications.</span>
        </mat-checkbox>
      </div>
      @if (showErrors && !isAnswered(school)) {
        <div class="d-flex align-items-center gap-2 mt-1">
          <i class="icon-info icon-red" style="width: 16px; height: 16px; flex-shrink: 0;"></i>
          <p class="text-alert mb-0" style="font-size: 12px" rtI18n>Please make a selection for this school.</p>
        </div>
      }
    </div>
  }
</div>
